import { isIssueRow, queueWords, type BoardRow } from '@claims/core';

/** THE SYSTEM IS DOING THE WORK (ported 2026-10-23 from the medrec console's system-working lane, its PR #340, under Rod's standing rule of
 *  10-11 that the two consoles stay matched; his words there, 10-23 8:42 am PT: "can we highlight this row a different color so we dont
 *  action, also at the top of the side card with a bar at the top saying system doing work"). Sweet Claims already knows these rows: the
 *  Queue folds them into "The system is handling N" (core todo.ts). They now wear the medrec console's look in its calm work tint
 *  (styles/system-working.css): the row's cells, a "System working" tag before the row's sentence, and a bar at the top of the row's panel.
 *  What the system is doing is the row's own words, as the Queue writes them (core queueWords). No new rule picks the rows, and no button
 *  changes: what a row offers is Sweet Claims' own, as before. */

/** The rows the Queue folds into "The system is handling N" (core todo.ts `buildTodo` and `buildQueue`): a working row that is not a
 *  person's issue (a letter the system could not send is one, so it stays in its group). The same rule, so the tint is on that fold's rows. */
export const systemHandles = (r: BoardRow): boolean => r.status === 'working' && !isIssueRow(r);

/** The look's fixed words, the medrec console's (so both consoles say the same), and the gear. */
export const SYSTEM_WORKING_WORDS = Object.freeze({ icon: '\u{2699}\u{FE0F}', tag: 'System working', bar: 'System doing work' });

/** What the system is doing: the row's own words, as its What to do cell says them. */
export const systemDoes = (r: Pick<BoardRow, 'text'>): string => queueWords(r.text);

/** The row's tag, first in its What to do cell: the gear, "System working", and what the system is doing in its hover. */
export function SystemWorkingTag({ r }: { r: Pick<BoardRow, 'text'> }) {
  return (
    <span className="sw-tag" title={systemDoes(r)} data-testid="row-system-working">
      <span className="sw-ic" aria-hidden="true">{SYSTEM_WORKING_WORDS.icon}</span>
      {SYSTEM_WORKING_WORDS.tag}
    </span>
  );
}

/** The bar at the very top of the row's panel: "System doing work: AI calling Allstate now (started 12:21 pm)". A status, so a screen reader
 *  hears it when the panel opens. */
export function SystemWorkingBar({ r }: { r: Pick<BoardRow, 'text'> }) {
  return (
    <p className="sw-bar" role="status" data-testid="sw-bar">
      <span className="sw-ic" aria-hidden="true">{SYSTEM_WORKING_WORDS.icon}</span>
      <span>{`${SYSTEM_WORKING_WORDS.bar}: ${systemDoes(r)}`}</span>
    </p>
  );
}
